/* mt-series-page.js */
(function () {
  'use strict';

  var sidebar = document.querySelector('.mt-series-page__sidebar');
  var overlay = document.querySelector('.mt-series-sidebar__overlay');

  function openSidebar() {
    if (sidebar) sidebar.classList.add('mt-series-page__sidebar--open');
    if (overlay) overlay.classList.add('mt-series-sidebar__overlay--visible');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    if (sidebar) sidebar.classList.remove('mt-series-page__sidebar--open');
    if (overlay) overlay.classList.remove('mt-series-sidebar__overlay--visible');
    document.body.style.overflow = '';
  }

  // Filter 按钮打开抽屉
  var filterToggle = document.querySelector('.mt-series-page__filter-toggle');
  if (filterToggle) {
    filterToggle.addEventListener('click', openSidebar);
  }

  // 关闭按钮
  var closeBtn = document.querySelector('.mt-series-sidebar__close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeSidebar);
  }

  // 点击遮罩关闭
  if (overlay) {
    overlay.addEventListener('click', closeSidebar);
  }

  // ── Sidebar group toggle ──────────────────────────────────────────────────
  document.querySelectorAll('.mt-series-sidebar__group-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var group = this.closest('.mt-series-sidebar__group');
      group.classList.toggle('mt-series-sidebar__group--active');
    });
  });

  // ── Sub-group toggle ──────────────────────────────────────────────────────
  document.querySelectorAll('.mt-series-sidebar__subgroup-header').forEach(function (header) {
    header.addEventListener('click', function (e) {
      var sub = this.closest('.mt-series-sidebar__subgroup');
      var hasBody = sub.querySelector('.mt-series-sidebar__subgroup-body');
      // 没有细分项目时，允许 <a> 正常跳转
      if (!hasBody) return;
      e.preventDefault(); // 有细分项目时阻止跳转，只做展开/折叠
      sub.classList.toggle('mt-series-sidebar__subgroup--active');
      var icon = this.querySelector('.mt-series-sidebar__subgroup-icon');
      if (icon) {
        var isActive = sub.classList.contains('mt-series-sidebar__subgroup--active');
        icon.innerHTML = isActive
          ? '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 9H14.25" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.02269 3.75L9.00896 14.25" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.75 9H14.25" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
    });
  });

  // ── Filter item checkboxes (multi-select) ────────────────────────────────
  var selectedCollections = new Set();
  var mainEl = document.querySelector('.mt-series-page__main');
  var gridEl = document.querySelector('.mt-series-page__grid');

  // 优先从 data 属性取，fallback 从 URL 路径解析 /collections/{handle}
  var pathMatch = window.location.pathname.match(/^\/collections\/([^\/]+)/);
  var currentCollectionHandle = (mainEl && mainEl.dataset.currentCollection) || (pathMatch && pathMatch[1]) || '';

  // 初始化：优先读取 URL 中的 collections 参数，否则用当前页的 collection
  (function initSelected() {
    var url = new URL(window.location.href);
    var param = url.searchParams.get('collections'); // null = 参数不存在；'' = 用户主动清空

    if (param !== null && param !== '') {
      // 有具体选中项
      param.split(',').forEach(function (h) { if (h) selectedCollections.add(h); });
    } else if (param === null && currentCollectionHandle) {
      // 首次进入页面，默认勾选当前 collection
      selectedCollections.add(currentCollectionHandle);
    }
    // param === '' 时：用户已主动取消所有勾选，不回填

    // 同步 checkbox 状态，并展开包含已选项的 group / subgroup
    document.querySelectorAll('.mt-series-sidebar__checkbox-input').forEach(function (input) {
      var col = input.dataset.collection;
      if (selectedCollections.has(col)) {
        input.checked = true;
        var item = input.closest('.mt-series-sidebar__item');
        if (item) item.classList.add('mt-series-sidebar__item--active');

        // 展开父级 subgroup（三级结构才有）
        var subgroup = input.closest('.mt-series-sidebar__subgroup');
        if (subgroup) subgroup.classList.add('mt-series-sidebar__subgroup--active');

        // 展开父级 group（所有层级都要展开）
        var group = input.closest('.mt-series-sidebar__group');
        if (group) group.classList.add('mt-series-sidebar__group--active');
      }
    });

    // 如果 URL 带了多选参数，需要重新渲染合并产品
    if (param !== null && param !== '' && selectedCollections.size >= 1) {
      loadMultiCollections(Array.from(selectedCollections));
    }
  })();

  function loadMultiCollections(handles) {
    if (mainEl) mainEl.classList.add('mt-series-page__main--loading');

    loadMultiCollections._token = (loadMultiCollections._token || 0) + 1;
    var token = loadMultiCollections._token;

    // 拉取单个 collection 的所有产品（自动翻页，突破 250 限制）
    function fetchAllProducts(handle, page, accumulated) {
      page = page || 1;
      accumulated = accumulated || [];
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = data.products || [];
          var all = accumulated.concat(products);
          // 如果本页满 250 条，可能还有下一页
          if (products.length === 250) {
            return fetchAllProducts(handle, page + 1, all);
          }
          return all;
        });
    }

    // 每个 collection 单独容错：失败返回空数组，不影响其他
    var promises = handles.map(function (handle) {
      return fetchAllProducts(handle).catch(function (err) {
        console.warn('[mt-series] 加载 collection 失败:', handle, err);
        return [];
      });
    });

    Promise.all(promises).then(function (results) {
      if (token !== loadMultiCollections._token) return;

      var seen = {};
      var merged = [];
      results.forEach(function (products) {
        products.forEach(function (p) {
          if (!seen[p.id]) { seen[p.id] = true; merged.push(p); }
        });
      });
      renderProducts(merged);
      if (mainEl) mainEl.classList.remove('mt-series-page__main--loading');
    }).catch(function () {
      if (token !== loadMultiCollections._token) return;
      if (mainEl) mainEl.classList.remove('mt-series-page__main--loading');
    });
  }

  var currentPage = 1;
  var allProducts = [];
  var perPage = mainEl ? (parseInt(mainEl.dataset.productsPerPage) || 9) : 9;

  function renderProducts(products) {
    allProducts = products;
    currentPage = 1;
    renderPage();
  }

  function renderPage() {
    // 找到 grid，如果不存在则创建
    var grid = document.querySelector('.mt-series-page__grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'mt-series-page__grid';
      var loading = mainEl ? mainEl.querySelector('.mt-series-page__loading') : null;
      if (loading && loading.nextSibling) {
        mainEl.insertBefore(grid, loading.nextSibling);
      } else if (mainEl) {
        mainEl.appendChild(grid);
      }
    }

    // 移除旧的分页
    var oldPagination = mainEl ? mainEl.querySelector('.mt-series-page__pagination') : null;
    if (oldPagination) oldPagination.remove();

    if (allProducts.length === 0) {
      grid.innerHTML = '<p style="color:#999;font-size:14px;font-family:Josefin Sans;grid-column:1/-1;">No products found in this collection.</p>';
      return;
    }

    var totalPages = Math.ceil(allProducts.length / perPage);
    var start = (currentPage - 1) * perPage;
    var pageProducts = allProducts.slice(start, start + perPage);

    grid.innerHTML = pageProducts.map(function (p) {
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var price = formatMoney(p.variants[0].price);
      var comparePrice = '';
      p.variants.forEach(function (v) {
        if (v.compare_at_price && parseInt(v.compare_at_price) > parseInt(v.price)) {
          comparePrice = formatMoney(v.compare_at_price);
        }
      });
      return '<a href="/products/' + p.handle + '" class="mt-series-card">'
        + '<div class="mt-series-card__media">'
        + (img ? '<img src="' + img + '" alt="' + escHtml(p.title) + '" loading="lazy" width="600" height="600">' : '')
        + '</div>'
        + '<div class="mt-series-card__info">'
        + '<h3 class="mt-series-card__title">' + escHtml(p.title) + '</h3>'
        + '<div class="mt-series-card__prices">'
        + (comparePrice ? '<span class="mt-series-card__price-compare">' + comparePrice + '</span>' : '')
        + '<span class="mt-series-card__price">' + price + '</span>'
        + '</div></div></a>';
    }).join('');

    // 渲染分页
    if (totalPages > 1) {
      var paginationEl = document.createElement('div');
      paginationEl.className = 'mt-series-page__pagination';

      // 上一页
      if (currentPage > 1) {
        var prev = document.createElement('a');
        prev.className = 'prev';
        prev.href = '#';
        prev.setAttribute('aria-label', 'Previous page');
        prev.innerHTML = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          currentPage--;
          renderPage();
          mainEl && mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        paginationEl.appendChild(prev);
      }

      // 页码（头尾各2页 + 当前页前后1页，其余用省略号）
      var pageNums = [];
      for (var i = 1; i <= totalPages; i++) {
        if (
          i <= 2 ||                          // 头部
          i >= totalPages - 1 ||             // 尾部
          (i >= currentPage - 1 && i <= currentPage + 1) // 当前页附近
        ) {
          pageNums.push(i);
        }
      }
      // 去重排序后插入省略号
      var lastNum = 0;
      pageNums.forEach(function (page) {
        if (lastNum && page - lastNum > 1) {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'pagination-ellipsis';
          ellipsis.textContent = '…';
          paginationEl.appendChild(ellipsis);
        }
        if (page === currentPage) {
          var span = document.createElement('span');
          span.className = 'current';
          span.textContent = page;
          paginationEl.appendChild(span);
        } else {
          (function (p) {
            var a = document.createElement('a');
            a.href = '#';
            a.textContent = p;
            a.addEventListener('click', function (e) {
              e.preventDefault();
              currentPage = p;
              renderPage();
              mainEl && mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            paginationEl.appendChild(a);
          })(page);
        }
        lastNum = page;
      });

      // 下一页
      if (currentPage < totalPages) {
        var next = document.createElement('a');
        next.className = 'next';
        next.href = '#';
        next.setAttribute('aria-label', 'Next page');
        next.innerHTML = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        next.addEventListener('click', function (e) {
          e.preventDefault();
          currentPage++;
          renderPage();
          mainEl && mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        paginationEl.appendChild(next);
      }

      grid.after(paginationEl);
    }
  }

  function formatMoney(cents) {
    return '$' + (parseInt(cents) / 100).toFixed(2);
  }

  function escHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function applySelection() {
    var cols = Array.from(selectedCollections);

    if (cols.length === 0) {
      // 全部取消：回到当前 collection 页，用空字符串标记不回填
      var base = currentCollectionHandle ? '/collections/' + currentCollectionHandle : window.location.pathname;
      window.location.href = base + '?collections=';
      return;
    }

    // 以第一个选中的 collection 作为页面基准 URL，携带完整选中列表
    var baseCollection = cols[0];
    var url = new URL('/collections/' + baseCollection, window.location.origin);
    url.searchParams.set('collections', cols.join(','));

    window.location.href = url.toString();
  }

  document.querySelectorAll('.mt-series-sidebar__checkbox-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var col = this.dataset.collection;
      if (!col) return;

      if (this.checked) {
        selectedCollections.add(col);
        this.closest('.mt-series-sidebar__item').classList.add('mt-series-sidebar__item--active');
      } else {
        selectedCollections.delete(col);
        this.closest('.mt-series-sidebar__item').classList.remove('mt-series-sidebar__item--active');
      }

      applySelection();
    });
  });
  var sortSelect = document.querySelector('.mt-series-page__sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

})();
